<template>
  <div class="vertical-bar-chart-node">
    <ChartHeader
      :value="value"
      :display-chart="displayChart"
      @set-display-chart="setDisplayChart"
    />
    <div class="vertical-bar-chart-container">
      <svg v-show="displayChart" ref="chart" class="pigeondoc-chart vertical-bar-chart"></svg>
      <VerticalBarChartTable :value="value" v-show="!displayChart" />
    </div>
  </div>
</template>

<script>
import ChartHeader from '../ChartHeader/ChartHeader.vue';
import VerticalBarChartTable from './VerticalBarChartTable.vue';
import verticalBarChartMixin from './verticalBarChartMixin.js';

export default {
  name: 'VerticalBarChart',
  mixins: [verticalBarChartMixin],
  components: {
    ChartHeader,
    VerticalBarChartTable,
  },
  data() {
    return {
      displayChart: true,
    };
  },
  methods: {
    setDisplayChart(value) {
      this.displayChart = value;
    },
  },
};
</script>

<style>
.vertical-bar-chart-node {
  margin: 4rem 0;
}

.vertical-bar-chart-container {
  margin: 0 5%;
}

.vertical-bar-chart-container svg {
  width: 100%;
}
</style>
